import initSupportedLanguages from './initSupportedLanguages';
import store from '../store/store';
import SupportedLanguage from '../store/schema/SupportedLanguage';

export default async function initAndGetSupportedLanguageMap(): Promise<
    Map<string, SupportedLanguage>
> {
    await initSupportedLanguages();
    return store.supportedLanguageMap;
}
